import type { NavImpactSurfaces } from '../arms';

export const spec = (): Partial<NavImpactSurfaces> => ({
  statStyle: 'plain',
  statLayout: 'stacked',
});
